import React from "react";

import { Helmet } from "react-helmet";



function Contact(){
return(
<div>


<Helmet>
 
<title>Codeexampler Contact Us</title>
<meta name="description" content="Codeexampler Contact Us.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, python tutorial,c# tutorial for beginners in deeply knowledge " />
<link rel="canonical" href="https://www.codeexampler.com/contact-us" />
</Helmet>



    <h1 className="m-5">Contact Us</h1>

    <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdX30aJL6D_aCM_YHV1ZpZj04Tn8S6FiWp7kAGbIcUrLg0Cvg/viewform?embedded=true" width="100%" height="800" frameborder="500" marginheight="200" marginwidth="200">Loading…</iframe>
    <h1 className="mt-5"> </h1>
 

 
    </div>

)

}
export default Contact;